export const handleBackNavigation = () => {
  const els = document.querySelectorAll(`.page-transition-fade-out`);
  els?els.forEach((el)=>el.remove()):``;
}

export const fadeInTransition = () => {
  //ページに訪れるとき
  const navType = performance.getEntriesByType("navigation")[0]?.type;
  if (navType === "back_forward") {
    console.log('back');
    handleBackNavigation();
  }
  setTimeout(() => {
    document.querySelector('div.page-transition')?.remove();
  }, 800);
}

// ページ遷移前のフェードアウト
export const setupPageTransition = () => {
  document.addEventListener('click', (e) => {
    const target = e.target;
    if (target instanceof HTMLAnchorElement) {
      const href = target.getAttribute('href');

      if (!href || href.startsWith('#') || target.target === '_blank' || target.hostname !== location.hostname) {
        return;
      }

      e.preventDefault();

      const transitionEl = document.querySelector('.page-transition');
      transitionEl?.classList.add('page-transition-fade-out');

      setTimeout(() => {
        window.location.href = href;
      }, 300);
    }
  });
};


